module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "lexus-talk.ed3d608b.png";